import { cn } from 'cn';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LogoDark from '@/assets/logo.svg?react';
import LogoLight from '@/assets/logo-darkmode.svg?react';

export function Logo({
  className,
  mode = 'dark',
}: {
  className?: string;
  mode?: 'dark' | 'light';
}) {
  const { t } = useTranslation();
  const title = t('app.title');

  return (
    <figure className="text-white">
      <Link to="/" className="flex items-center justify-center">
        {mode === 'dark' ? (
          <LogoLight
            aria-label={t('app.title')}
            data-testid="logo"
            className={cn('h-6 w-40', className)}
          />
        ) : (
          <LogoDark
            aria-label={t('app.title')}
            data-testid="logo"
            className={cn('h-6 w-40', className)}
          />
        )}
      </Link>
      <figcaption className="ml-3 hidden">{title}</figcaption>
    </figure>
  );
}
